import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const BannerWrapper = styled.div`
  position: relative;
  display: grid;
  row-gap: 2em;
  padding: 4em 0em 6em 0em;

  @media screen and (max-width: ${layout.sm}) {
    padding: 2rem 0;
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  margin-top: -15% !important;
  max-width: 100% !important;
  z-index: -1;

  &:after {
    content: " ";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    background: linear-gradient(180deg, #EDF8FA 31.66%, rgba(255, 255, 255, 0) 101.44%);
    transform: rotate(180deg);
    height: 30%;
    z-index: 1;
  }
`

export const LinearGradient = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 30%;
  z-index: 1;
  background: linear-gradient(180deg, #FFFFFF 25%, rgba(196, 196, 196, 0) 100%);
`

export const BannerHeadingContainer = styled.div`
  max-width: 1060px;
  margin: 0 auto;
  justify-self: center;
  padding: 0 30px;

  & > h1 {
    line-height: 1.4em;
  }
`

export const BannerParagraphContainer = styled.div`
  max-width: 540px;
  margin: 0 auto;
  justify-self: center;
  padding: 0 22px;
`
